import apiSubmitLink from '../../utils/link/linkApi';

export const LINK_SUCCESS = 'LINK_SUCCESS';
export const LINK_INITIATED = 'LINK_INITIATED';
export const LINK_COMPLETE = 'LINK_COMPLETE';

const initiatedActionIndentifiers = [];

export const onCompleteLink = (
    apiRequestData,
    actionCompletedTime,
    actionIdentifier,
    isVisual
) => dispatch => {
    if (
        initiatedActionIndentifiers.find(identifier => identifier === apiRequestData.id)
    ) {
        return;
    }
    // for tracking third party to not await server response;
    dispatch({ type: LINK_COMPLETE });
    dispatch({
        type: LINK_INITIATED,
        payload: { actionIdentifier }
    });

    apiSubmitLink(apiRequestData, actionCompletedTime, isVisual).then(data => {
        dispatch({
            type: LINK_SUCCESS,
            payload: { ...data, actionIdentifier }
        });
    });

    initiatedActionIndentifiers.push(apiRequestData.id);

    return true;
};
